import { create } from 'zustand'

interface State {
  open: boolean
}

interface Actions {
  // Opens the step-up dialog and settles once the user verifies (true) or cancels (false).
  // Null while a dialog is already open: a request made from inside it must never wait on that dialog.
  request: () => Promise<boolean> | null
  resolve: (ok: boolean) => void
}

type Resolver = (ok: boolean) => void

let pending: Promise<boolean> | null = null
let settle: Resolver | null = null

export const useStepUpState = create<State & Actions>((set) => ({
  open: false,
  request() {
    if (pending) return null

    pending = new Promise<boolean>((resolve) => {
      settle = resolve
    })
    set({ open: true })

    return pending
  },
  resolve(ok) {
    const current = settle
    pending = null
    settle = null
    set({ open: false })
    current?.(ok)
  },
}))

export const stepUpState = useStepUpState.getState()
